export enum Datatype {
  Text = 'text',
  Number = 'number',
  Password = 'password',
  Email = 'email'
}
